@if (getText(data); as text) {
	<span [appTooltip]="tooltip ?? text" [class]="className">{{ text }}</span>
}
@if (getLabelWithTooltip(data); as labelWithTooltip) {
	<span class="label-icon" [appTooltip]="labelWithTooltip.tooltip">
		@if (labelWithTooltip.icon) {
			<app-icon [name]="labelWithTooltip.icon" color="primary-1" size="small"></app-icon>
		}
	</span>
}
